import Button from '../common/Button'

const InvestorMatchUpgradeCard = ({ title, subTitle, btnTxt, price, wrapperClass, redirectLink }) => {
    return (
        <div className='shadow bg1 p1rem br20px pr'
            style={{
                width: '280px'
            }}
        >
            <div
                className='br8px pa tac'
                style={{
                    background: title.includes('AppStore') ? '#FFECEE' : '#E4FFEB',
                    color: title.includes('AppStore') ? '#FC7785' : '#44D991',
                    border: title.includes('AppStore') ? '1px solid #FC7785' : '1px solid #A8EFAB',
                    top: '-18px',
                    minWidth: title.includes('AppStore') ? '120px' : '80px',
                    left: '50%',
                    paddingTop: '0.25rem',
                    paddingBottom: '0.25rem',
                    transform: `translateX(-50%)`
                }}>
                {title}
            </div>
            <div className='w100 df fdc aic jcc'>
                <div className='py1rem'>
                    <p className='c15'><span className='c3 fs1-5rem fw600'>£{price}</span> / month*</p>
                    <p className='op60 c15 w100 tac fs12px'>* billed annually</p>
                </div>

                <h3
                    className='fs1rem c15 tac tac mb1rem'
                    style={{ width: '220px' }}
                >
                    {subTitle}
                </h3>
                <Button
                    text={btnTxt}
                    btnType="warning"
                    onClick={() => window.location.href = redirectLink}
                />
            </div>
        </div>
    )
}

export default InvestorMatchUpgradeCard